import { Validators } from "@angular/forms";
import { APP_VALIDATION_REGEX } from "src/app/app.contant";
import { IFormField, FieldEnum, SubFieldEnum } from "../../shared/models/form-field";
import { TodayDateValidator } from "../../shared/services/custom-app-validators.service";
import { of } from "rxjs";

export const ITEM_CATEGORY : Array<{category: string, value : string}> = [
    {
        category : "Standard",
        value : "Standard"
    },
    // {
    //     category : "Limit",
    //     value : "Limit"
    // },
    // {
    //     category : "Consignment",
    //     value : "Consignment"
    // },
    // {
    //     category : "Subcontracting",
    //     value : "Subcontracting"
    // },
    // {
    //     category : "Third-party",
    //     value : "Third-party"
    // },
    // {
    //     category : "Text",
    //     value : "Text"
    // },
    {
        category : "Service",
        value : "Service"
    }
];

export const ITEM_UNIT_LIST : Array<{unit:string, value:string}> = [
    {
        "unit": "AAS",
        "value": "AAS"
    },
    {
        "unit": "B",
        "value": "B"
    },
    {
        "unit": "BAG",
        "value": "BAG"
    },
    {
        "unit": "BDL",
        "value": "BDL"
    },
    {
        "unit": "BEO",
        "value": "BEO"
    },
    {
        "unit": "BEU",
        "value": "BEU"
    },
    {
        "unit": "BOT",
        "value": "BOT"
    },
    {
        "unit": "BOX",
        "value": "BOX"
    },
    {
        "unit": "CBY",
        "value": "CBY"
    },
    {
        "unit": "CNT",
        "value": "CNT"
    },
    {
        "unit": "CS",
        "value": "CS"
    },
    {
        "unit": "CUR",
        "value": "CUR"
    },
    {
        "unit": "CYL",
        "value": "CYL"
    },
    {
        "unit": "DEG",
        "value": "DEG"
    },
    {
        "unit": "DR",
        "value": "DR"
    },
    {
        "unit": "DZ",
        "value": "DZ"
    },
    {
        "unit": "EA",
        "value": "EA"
    },
    {
        "unit": "EE",
        "value": "EE"
    },
    {
        "unit": "EML",
        "value": "EML"
    },
    {
        "unit": "FN",
        "value": "FN"
    },
    {
        "unit": "G/L",
        "value": "G/L"
    },
    {
        "unit": "GAU",
        "value": "GAU"
    },
    {
        "unit": "GBY",
        "value": "GBY"
    },
    {
        "unit": "GRO",
        "value": "GRO"
    },
    {
        "unit": "GW",
        "value": "GW"
    },
    {
        "unit": "KAN",
        "value": "KAN"
    },
    {
        "unit": "KAR",
        "value": "KAR"
    },
    {
        "unit": "KGW",
        "value": "KGW"
    },
    {
        "unit": "KI",
        "value": "KI"
    },
    {
        "unit": "KIT",
        "value": "KIT"
    },
    {
        "unit": "KPC",
        "value": "KPC"
    },
    {
        "unit": "KWK",
        "value": "KWK"
    },
    {
        "unit": "LE",
        "value": "LE"
    },
    {
        "unit": "LOT",
        "value": "LOT"
    },
    {
        "unit": "LSO",
        "value": "LSO"
    },
    {
        "unit": "LSU",
        "value": "LSU"
    },
    {
        "unit": "MBY",
        "value": "MBY"
    },
    {
        "unit": "MD",
        "value": "MD"
    },
    {
        "unit": "MLW",
        "value": "MLW"
    },
    {
        "unit": "MPC",
        "value": "MPC"
    },
    {
        "unit": "PAA",
        "value": "PAA"
    },
    {
        "unit": "PAD",
        "value": "PAD"
    },
    {
        "unit": "PAK",
        "value": "PAK"
    },
    {
        "unit": "PAL",
        "value": "PAL"
    },
    {
        "unit": "PAN",
        "value": "PAN"
    },
    {
        "unit": "PCS",
        "value": "PCS"
    },
    {
        "unit": "PL",
        "value": "PL"
    },
    {
        "unit": "PRS",
        "value": "PRS"
    },
    {
        "unit": "ROL",
        "value": "ROL"
    },
    {
        "unit": "SBL",
        "value": "SBL"
    },
    {
        "unit": "SET",
        "value": "SET"
    },
    {
        "unit": "ST",
        "value": "ST"
    },
    {
        "unit": "STH",
        "value": "STH"
    },
    {
        "unit": "TBY",
        "value": "TBY"
    },
    {
        "unit": "TH",
        "value": "TH"
    },
    {
        "unit": "TMS",
        "value": "TMS"
    },
    {
        "unit": "TOT",
        "value": "TOT"
    },
    {
        "unit": "TST",
        "value": "TST"
    },
    {
        "unit": "VAL",
        "value": "VAL"
    },
    {
        "unit": "YDK",
        "value": "YDK"
    },
    {
        "unit": "YRD",
        "value": "YRD"
    },
    {
        "unit": "ZPC",
        "value": "ZPC"
    }
]


export const PR_MATERIAL_MASTER_FORMFIELDS : Array<IFormField> = [
    {
        fieldName : "item_category",
        displayName : "Item Category",
        defaultValue : null,
        labelName : "Item Category",
        placeholder : "Item Category",
        // validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['ONE_CHARACTER'])],
        // fieldType : FieldEnum.INPUT,
        // fieldSubType : SubFieldEnum.TEXT,
        // size : "col-md-2",
        // UIVisible : true
        validators : [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "value",
            bindValue : "category",
            dataFields : []
        },
        required : true
    },
    // {
    //     fieldName : "service_category",
    //     displayName : "Service Category",
    //     defaultValue : "",
    //     labelName : "Service Category",
    //     placeholder : "Service Category",
    //     validators : null,
    //     fieldType : FieldEnum.SELECT,
    //     fieldSubType : SubFieldEnum.TEXT,
    //     size : "col-md-2",
    //     UIVisible : true,
    //     selectFields : {
    //         apiAsync$ : of(),
    //         bindLabel : "category",
    //         bindValue : "category_description",
    //         dataFields : []
    //     },
    //     hasCondition:true,
    //     condition:"Service"
    // },
    {
        fieldName : "line_item_number",
        displayName : "Line Item Number",
        defaultValue : "",
        labelName : "Line Item Number",
        placeholder : "Line Item Number",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : false,
        updateOn : "blur",
    },
    {
        fieldName : "with_material",
        displayName : "With Material No",
        defaultValue : "",
        labelName : "With Material No",
        placeholder : "With Material No",
        validators : null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "key",
            bindValue : "value",
            dataFields : [{key:"Yes",value:true},{key:"No",value:false}]
        },
        hasCondition:true,
        condition:"Standard"
    },
    {
        fieldName : "material_code",
        displayName : "Material/ Service Code",
        defaultValue : null,
        labelName : "Material/ Service Code",
        placeholder : "Material/ Service Code",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        updateOn : "blur",
    },
    {
        fieldName : "esn",
        displayName : "ESN",
        defaultValue : "",
        labelName : "ESN",
        placeholder : "ESN",
        validators : [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "esn",
            bindValue : "esn",
            dataFields : []
        },
        required : true
    },
    {
        fieldName : "hsn_sac",
        displayName : "HSN/SAC",
        defaultValue : null,
        labelName : "HSN/SAC",
        placeholder : "HSN/SAC",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        updateOn : "blur",
        required : true
    },
    {
        fieldName : "short_text",
        displayName : "Short Text",
        defaultValue : "",
        labelName : "Short Text",
        placeholder : "Short Text",
        validators : [Validators.required],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required: true
    },
    {
        fieldName : "matl_group",
        displayName : "Material Group",
        defaultValue : "",
        labelName : "Material Group",
        placeholder : "Material Group",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : false
    },
    {
        fieldName : "quantity",
        displayName : "Quantity",
        defaultValue : "",
        labelName : "Quantity",
        placeholder : "Quantity",
        validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['FLOAT_NUMBER_PATTERN'])],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "ordering_unit",
        displayName : "Ordering Unit",
        defaultValue : "",
        labelName : "Ordering Unit",
        placeholder : "Ordering Unit",
        validators : [Validators.required],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true
    },
    {
        fieldName : "price",
        displayName : "Budget",
        defaultValue : 0.00,
        labelName : "Budget",
        placeholder : "Budget",
        validators : [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['FLOAT_NUMBER_PATTERN'])],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "currency",
        displayName : "Currency",
        defaultValue : "",
        labelName : "Currency",
        placeholder : "Currency",
        validators : [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "code",
            bindValue : "code",
            dataFields : []
        }
    },
    {
        fieldName : "delivery_date",
        displayName : "Delivery Date",
        defaultValue : "",
        labelName : "Delivery Date",
        placeholder : "Delivery Date",
        validators : [Validators.required, TodayDateValidator()],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.DATE,
        size : "col-md-2",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "warranties",
        displayName : "Warranties",
        defaultValue : "",
        labelName : "Warranties",
        placeholder : "Warranties",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : true
    },
    {
        fieldName : "item_desc",
        displayName : "Item Desc(Max Char:1500)",
        defaultValue : "",
        labelName : "Item Desc",
        placeholder : "Item Desc",
        validators : [Validators.required],
        fieldType : FieldEnum.TEXTAREA,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true,
        required : true
    },
    {
        fieldName : "po_text",
        displayName : "PO Text(Max Char:1500)",
        defaultValue : "",
        labelName : "PO Text",
        placeholder : "PO Text",
        validators : [Validators.required],
        fieldType : FieldEnum.TEXTAREA,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true,
        required:true
    },
];



export const PR_ACCOUNT_DETAILS_FORMFIELDS : Array<IFormField> = [  
    {
        fieldName : "acc_assignment_category",
        displayName : "Account Assignment Category",
        defaultValue : "",
        labelName : "Account Assignment Category",
        placeholder : "Account Assignment Category",
        validators : null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "acc_assignment_category",
            bindValue : "acc_assignment_category",
            dataFields : []
        },
        // required : true
    },
    {
        fieldName : "acc_assignment_value",
        displayName : "Account Assignment Value",
        defaultValue : "",
        labelName : "Account Assignment Value",
        placeholder : "Account Assignment Value",
        validators : null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "acc_assignment_value",
            bindValue : "acc_assignment_value",
            dataFields : []
        },
        // required : true
    },
    {
        fieldName : "gl_account",
        displayName : "GL Account",
        defaultValue : "",
        labelName : "GL Account",
        placeholder : "GL Account",
        validators : [Validators.pattern(APP_VALIDATION_REGEX['ONLY_NUMBER_PATTERN'])],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "gl_account",
            bindValue : "gl_account",
            dataFields : []
        },
        // required : true
    },
    {
        fieldName: "sales_order_no",
        displayName: "Sales Item No",
        defaultValue: "",
        labelName: "Sales Item No",
        placeholder: "Sales Item No",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: true,
    },
    {
        fieldName: "wbs_element",
        displayName: "WBS Element",
        defaultValue: null,
        labelName: "WBS Element",
        placeholder: "WBS Element",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: true,
    },
    {
        fieldName: "cost_center",
        displayName: "Cost Center",
        defaultValue: null,
        labelName: "Cost Center",
        placeholder: "Cost Center",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: true,
    },
    {
        fieldName: "WBS_Budget_Total_Value",
        displayName: "WBS Budget Total  Value",
        defaultValue: null,
        labelName: "WBS Budget Total  Value",
        placeholder: "WBS Budget Total  Value",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: false,
    },
    {
        fieldName: "WBS_Utilized_Value",
        displayName: "WBS PO Utilized Value",
        defaultValue: null,
        labelName: "WBS PO Utilized Value",
        placeholder: "WBS PO Utilized Value",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: false,
    },
    {
        fieldName: "WBS_Balance_Value",
        displayName: "WBS Balance Value",
        defaultValue: null,
        labelName: "WBS Balance Value",
        placeholder: "WBS Balance Value",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: false,
    },
    {
        fieldName: "Latest_PO_Number",
        displayName: "Latest PO Number",
        defaultValue: null,
        labelName: "Latest PO Number",
        placeholder: "Latest PO Number",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: false,
    },
    {
        fieldName: "FY_YEAR",
        displayName: "FY Year",
        defaultValue: null,
        labelName: "FY Year",
        placeholder: "FY Year",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-4",
        UIVisible: false,
    }
];


export const PR_VENDOR_DETAILS_FORMFIELDS : Array<IFormField> = [
    {
        fieldName : "vendor_code",
        displayName : "Vendor Code",
        defaultValue : "",
        labelName : "Vendor Code",
        placeholder : "Vendor Code",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true,
        updateOn : "blur"
    },
    {
        fieldName : "vendor_name",
        displayName : "Vendor Name",
        defaultValue : "",
        labelName : "Vendor Name",
        placeholder : "Vendor Name",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true
    },
    {
        fieldName : "vendor_location",
        displayName : "Vendor Location",
        defaultValue : "",
        labelName : "Vendor Location",
        placeholder : "Vendor Location",
        validators : null,
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : true
    }
];

export const PR_RC_DETAILS_FORMFIELDS : Array<IFormField> = [
    {
        fieldName : "rcid",
        displayName : "rcid",
        defaultValue : "",
        labelName : "rcid",
        placeholder : "rcid",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : false
    },
    {
        fieldName : "vendor_code",
        displayName : "vendor_code",
        defaultValue : "",
        labelName : "vendor_code",
        placeholder : "vendor_code",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : false
    },
    {
        fieldName : "vendor_location",
        displayName : "vendor_location",
        defaultValue : "",
        labelName : "vendor_location",
        placeholder : "vendor_location",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : false
    },
    {
        fieldName : "vendor_name",
        displayName : "vendor_name",
        defaultValue : "",
        labelName : "vendor_name",
        placeholder : "vendor_name",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-4",
        UIVisible : false
    },
    {
        fieldName : "material_code",
        displayName : "Material Code",
        defaultValue : "",
        labelName : "Material Code",
        placeholder : "Material Code",
        validators : [],
        fieldType : FieldEnum.INPUT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-2",
        UIVisible : false
    }
]